import type { QueryClient } from "@tanstack/react-query";

import { queryKeys } from "@/constants/query";
import { isValidOrgId } from "@/lib/utils";

/**
 * Org-scoped project lists (sidebar nav, project picker, redirect diff hook) share these
 * React Query keys. Call after chat tools create/update work so the left nav refreshes.
 */
export function invalidateOrgProjectListQueries(
  queryClient: QueryClient,
  orgId: string,
  options?: { openProjectId?: string },
): Promise<void> {
  if (!isValidOrgId(orgId)) {
    return Promise.resolve();
  }

  const tasks: Array<Promise<unknown>> = [
    queryClient.invalidateQueries({ queryKey: ["masterWorkItems", orgId] }),
    queryClient.invalidateQueries({
      queryKey: queryKeys.getProjectNavItems(orgId),
    }),
    queryClient.invalidateQueries({ queryKey: queryKeys.getProjectItems(orgId) }),
  ];

  const openProjectId = options?.openProjectId;
  if (openProjectId) {
    tasks.push(
      queryClient.invalidateQueries({
        queryKey: queryKeys.getWorkTreeById(openProjectId),
      }),
      queryClient.invalidateQueries({
        queryKey: queryKeys.getRecursiveWorkEstimates(openProjectId),
      }),
    );
  }

  return Promise.all(tasks).then(() => undefined);
}
